import classNames from 'classnames'
import { useEffect, useRef, useState } from 'react'

import removeTargetAttributeForHashAnchorTags from '@src/quince-site-common/src/utils/removeTargetAttributeForHashAnchorTags'
import ProductDetailsIconSection from '@src/quince-site-pdp/src/atoms/productDetailsIcon/product-details-icon-section'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'
import { convertRelativeToAbsoluteUrls } from '@src/utils/general.utils'

import styles from './product-description.module.scss'
import { getProductDescription } from './utils'

import type { ProductDescriptionProps } from './product-description.types'

export const ProductDescriptionLegacy = ({
  description,
  showNewPdpDesignV2,
  productDetailsIcons,
  showReadMoreInDesc,
  isB2BMode,
}: ProductDescriptionProps) => {
  const [showReadMore, setShowReadMore] = useState(false)
  const productFormContentRef = useRef<HTMLDivElement>(null)
  const productDescription = isB2BMode ? convertRelativeToAbsoluteUrls(description) : description

  useEffect(() => {
    removeTargetAttributeForHashAnchorTags(productFormContentRef.current)
  }, [])

  useEffect(() => {
    if (!productFormContentRef.current) return

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            trackEvent(TELEMETRY_EVENT_NAMES.PRODUCT_SUMMARY_IS_VISIBLE, {
              // eslint-disable-next-line i18next/no-literal-string
              entity_type: 'action',
              entity_id: 'product_summary',
            })
            observer.disconnect()
          }
        })
      },
      { threshold: 0.2 },
    )

    observer.observe(productFormContentRef.current)

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <div
      className={classNames(styles.productDescription__wrapper, {
        [styles.showReadMore ?? '']: showReadMore,
        [styles.showReadMoreInDesc ?? '']: showReadMoreInDesc,
        [styles.productDescription__wrapper__updatedDesignV2 ?? '']: showNewPdpDesignV2,
      })}
    >
      <div
        className={classNames(styles.productDescription__content, {
          [styles.productDescription__content__updatedDesignV2 ?? '']: showNewPdpDesignV2,
        })}
        ref={productFormContentRef}
        onClick={e => {
          if (showNewPdpDesignV2) return
          if ('readmore' in (e.target as HTMLElement).dataset) {
            if ((e.target as HTMLElement).dataset.readmore === 'true') {
              setShowReadMore(false)
            } else {
              setShowReadMore(true)
            }
          }
        }}
        //eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: getProductDescription(productDescription, showReadMore, showNewPdpDesignV2),
        }}
      />
      {showNewPdpDesignV2 && (
        <ProductDetailsIconSection
          icons={productDetailsIcons}
          showPdpV2UI={!!showNewPdpDesignV2}
          wrapperClassName={styles.productDescription__iconsWrapper}
        />
      )}
    </div>
  )
}
